export default __webpack_public_path__ + "images/person.v-159f232f48d8e4daca727b46e90ed6b7.svg";